import { useMemo } from 'react'

/** @typedef {import('semantic-ui-react').StrictDropdownItemProps[]} Options */
/** @typedef {import('shared/components/FilterGroup/container').Extra} Extra */
/**
 * @template T
 * @typedef {import('shared/components/FilterGroup').OnChangeValue<T>} OnChangeValue
 */

/**
 * @typedef InitialState
 * @property {[string, string]} filteredRange
 * @property {number} filterDatePresetOption
 * @property {Object<string, Options>} cachedOptions
 * @property {OnChangeValue<Extra>} filter
 */

/** @typedef {InitialState} State */

/**
 *
 * @typedef Action
 * @property {'SET_DATE_RANGE' | 'SET_CACHED_OPTIONS' | 'SET_FILTER'} type
 * @property {[string, string]} [filteredRange]
 * @property {number} [presetIndex]
 * @property {string} [key]
 * @property {Options} [options]
 * @property {object} [filter]
 */

/**
 * @param {State} state
 * @param {Action} action
 * @returns {object}
 */

export default function feedbackIndexReducer(state, action) {
  if (action.type === 'SET_DATE_RANGE') {
    return {
      ...state,
      filteredRange: action.filteredRange,
      filterDatePresetOption: action.presetIndex,
    }
  }

  if (action.type === 'SET_CACHED_OPTIONS') {
    const stateOptions = state.cachedOptions[action.key] || []
    const options = stateOptions.concat(action.options)
    const deduplicatedOptions = deduplicateOptions(options)
    return {
      ...state,
      cachedOptions: {
        ...state.cachedOptions,
        [action.key]: deduplicatedOptions,
      },
    }
  }

  if (action.type === 'SET_FILTER') {
    return {
      ...state,
      filter: action.filter,
    }
  }

  return state
}

/** @type {State} */
export const initialState = {
  filteredRange: ['', ''],
  filterDatePresetOption: 5, //90-day as a default
  cachedOptions: {},
  filter: null,
  extra: {},
}

/** @param {(action: Action) => void} dispatch */
export function useActions(dispatch) {
  return useMemo(() => {
    const actions = {
      setDateRange(filteredRange, presetIndex) {
        dispatch({ type: 'SET_DATE_RANGE', filteredRange, presetIndex })
      },
      setCacheOptions(key, options) {
        dispatch({ type: 'SET_CACHED_OPTIONS', key, options })
      },
      setFilter(filter) {
        dispatch({ type: 'SET_FILTER', filter })
      },
    }

    return actions
  }, [dispatch])
}

function deduplicateOptions(options) {
  const addedKeys = new Set()
  const filteredOptions = options.filter((option) => {
    const shouldAddToArray = !addedKeys.has(option.key)
    if (shouldAddToArray) {
      addedKeys.add(option.key)
      return true
    }

    return false
  })

  return filteredOptions
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/shared/components/FilterGroup/context/reducer.js